import { Spinner } from '../ui/Spinner';

interface OAuthButtonsProps {
  onGoogle: () => void;
  loadingProvider: 'google' | 'apple' | null;
  labelGoogle: string;
}

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
      <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
      <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" />
      <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
    </svg>
  );
}

const btnStyle: React.CSSProperties = {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.625rem',
  padding: '0.6875rem 1rem',
  borderRadius: 'var(--radius-md)',
  border: '1px solid var(--border-subtle)',
  backgroundColor: 'var(--bg-elevated)',
  color: 'var(--text-primary)',
  fontSize: 'var(--text-label)',
  fontWeight: 500,
  cursor: 'pointer',
  transition: 'background-color 150ms, border-color 150ms',
};

export function OAuthButtons({ onGoogle, loadingProvider, labelGoogle }: OAuthButtonsProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.625rem', marginBottom: '0.25rem' }}>
      <button
        type="button"
        onClick={onGoogle}
        disabled={loadingProvider !== null}
        style={btnStyle}
        onMouseEnter={e => (e.currentTarget.style.backgroundColor = 'var(--bg-card)')}
        onMouseLeave={e => (e.currentTarget.style.backgroundColor = 'var(--bg-elevated)')}
      >
        {loadingProvider === 'google' ? <Spinner size="sm" /> : <GoogleIcon />}
        {labelGoogle}
      </button>
    </div>
  );
}

export function OAuthDivider({ label }: { label: string }) {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '0.75rem',
      margin: '1.25rem 0 1rem',
    }}>
      <div style={{ flex: 1, height: '1px', backgroundColor: 'var(--border-subtle)' }} />
      <span style={{
        fontSize: 'var(--text-caption)',
        color: 'var(--text-muted)',
        whiteSpace: 'nowrap',
      }}>
        {label}
      </span>
      <div style={{ flex: 1, height: '1px', backgroundColor: 'var(--border-subtle)' }} />
    </div>
  );
}
